import { makeStyles } from "@material-ui/core";
import React from "react";

import { SiteIssue } from "../../../../dtos/site";
import { SiteIssueType } from "../../../../enums/SiteIssueType";
import { StandardTable } from "../../../shared/table";

import { SITE_ISSUE_TYPES } from "./consts";
import { SiteIssuesTableRow } from "./SiteIssuesTableRow";

const useStyles = makeStyles(() => ({
    tableContainer: {
        width: "100%",
        overflowX: "auto",
    },
    table: {
        "& tr td": {
            "&:first-child": {
                fontWeight: "normal", // overrides styles of StandartTable
            },
        },
    },
    issueTypeTh: {
        width: "70%",
    },
}));

interface Props {
    issuesByType: { [key in SiteIssueType]: SiteIssue[]; };
}

export function SiteIssuesTable({ issuesByType }: Props) {
    const classes = useStyles();

    const issueTypesWithIssues = SITE_ISSUE_TYPES.filter(issueType => issuesByType[issueType].length > 0);

    if (issueTypesWithIssues.length === 0) {
        return <></>;
    }

    return (
        <div className={classes.tableContainer}>
            <StandardTable className={classes.table}>
                <thead>
                    <tr>
                        <th className={classes.issueTypeTh}>System Issue Type</th>
                        <th>Issue Count</th>
                    </tr>
                </thead>

                <tbody>
                    {issueTypesWithIssues.map(issueType => (
                        <SiteIssuesTableRow
                            key={issueType}
                            issueType={issueType}
                            issues={issuesByType[issueType]}
                        />
                    ))}
                </tbody>
            </StandardTable>
        </div>
    );
}
